export const Permission = [
    {
        name: "สถิติข้อมูล",
        code: "Dashboard.Read",
        permit: false,
        actions: []
    },
    {
        name: "ตู้เอกสาร",
        code: "Documents.Read",
        permit: false,
        actions: [
            {
                name: "ตู้เอกสารของฉัน",
                code: "Documents.My.Read",
                permit: false,
                actions: [
                    
                ]
            },
            {
                name: "ตู้เอกสารที่แชร์กับฉัน",
                code: "Documents.Shared.Read",
                permit: false,
                actions: [
                    {
                        name: "ตู้เอกสาร/หน่วยงาน",
                        code: "Level1.Add",
                        permit: false,
                        actions: []
                    },
                    {
                        name: "ชั้นเอกสาร",
                        code: "Level2.Add",
                        permit: false,
                        actions: []
                    },
                    {
                        name: "แฟ้มเอกสาร",
                        code: "Level3.Add",
                        permit: false,
                        actions: []
                    },
                    {
                        name: "ประเภทเอกสาร",
                        code: "Level4.Add",
                        permit: false,
                        actions: []
                    },
                    {
                        name: "อัปโหลด",
                        code: "upload.Add",
                        permit: false,
                        actions: []
                    },
                ]
            },
        ]
    },
    {
        name: "รายงาน",
        code: "Report.Read",
        permit: false,
        actions: []
    },
    {
        name: "สถิติการใช้งาน",
        code: "Statistics.Read",
        permit: false,
        actions: [
            {
                name: "การใช้งานระบบ",
                code: "Statistics.Usage.Read",
                permit: false,
                actions: [
                    {
                        name: "ส่งออกเอกสาร",
                        code: "Statistics.Usage.Export",
                        permit: false,
                        actions: []
                    },
                ]
            },
            {
                name: "การดาวน์โหลด",
                code: "Statistics.Download.Read",
                permit: false,
                actions: [
                    {
                        name: "ส่งออกเอกสาร",
                        code: "Statistics.Download.Export",
                        permit: false,
                        actions: []
                    },
                ]
            },
        ]
    },
    {
        name: "ตั้งค่า",
        code: "Setting.Read",
        permit: false,
        actions: [
            {
                name: "จัดการผู้ใช้งาน",
                code: "Employees.Read",
                permit: false,
                actions: [
                    {
                        name: "เพิ่มผู้ใช้งาน",
                        code: "Employees.Add",
                        permit: false,
                        actions: []
                    },
                    {
                        name: "แก้ไขผู้ใช้งาน",
                        code: "Employees.Edit",
                        permit: false,
                        actions: []
                    },
                ]
            },
            {
                name: "จัดการบทบาท",
                code: "Role.Read",
                permit: false,
                actions: [
                    {
                        name: "เพิ่มบทบาท",
                        code: "Role.Add",
                        permit: false,
                        actions: []
                    },
                    {
                        name: "แก้ไขบทบาท",
                        code: "Role.Edit",
                        permit: false,
                        actions: []
                    },
                ]
            },
            {
                name: "จัดการตำแหน่ง",
                code: "Position.Read",
                permit: false,
                actions: [
                    {
                        name: "เพิ่มตำแหน่ง",
                        code: "Position.Add",
                        permit: false,
                        actions: []
                    },
                    {
                        name: "แก้ไขตำแหน่ง",
                        code: "Position.Edit",
                        permit: false,
                        actions: []
                    },
                ]
            },
            {
                name: "จัดการหน่วยงาน",
                code: "Department.Read",
                permit: false,
                actions: [
                    {
                        name: "เพิ่มหน่วยงาน",
                        code: "Department.Add",
                        permit: false,
                        actions: []
                    },
                    {
                        name: "แก้ไขหน่วยงาน",
                        code: "Department.Edit",
                        permit: false,
                        actions: []
                    },
                ]
            },
        ]
    },
    {
        name: "ปรับแต่ง",
        code: "Customize.Read",
        permit: false,
        actions: []
    },

]  